import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  header: {
    borderBottom: "1px solid gray",
    padding: theme.spacing(1, 2, 1, 3),
    width: "100%",
  },
  body: {
    display: "flex",
    flex: "1",
  },
  profile: {
    display: "flex",
    fontSize: "18px",
    color: `${theme.palette.primary.contrastText}`,
  },
  divider: {
    backgroundColor: theme.palette.primary.light,
  },
}));
